module.exports = __webpack_public_path__ + "ptc_momoro_F2.69235e1d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/momoro/parent_to_child/ptc_momoro_F2.jpg
// module id = w1XD
// module chunks = 0